import { render, staticRenderFns } from "./EmailMessageCard.vue?vue&type=template&id=af05dc62&scoped=true&lang=pug&"
import script from "./EmailMessageCard.vue?vue&type=script&lang=js&"
export * from "./EmailMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessageCard.vue?vue&type=style&index=0&id=af05dc62&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af05dc62",
  null
  
)

/* custom blocks */
import block0 from "./EmailMessageCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports